/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import Header from 'components/header/header'
import Instagram from 'images/svgs/instagram.svg'
import Facebook from 'images/svgs/facebook-square.svg'
import Twitter from 'images/svgs/twitter-square.svg'
import Div100vh from 'react-div-100vh'
import Helmet from 'react-helmet'
import appleIcon from 'images/icons/apple-touch-icon.png'
import favicon32 from 'images/icons/favicon-32x32.png'
import favicon16 from 'images/icons/favicon-16x16.png'
import openGraphImage from 'images/bantu-og.jpg'
import classnames from 'classnames'

const Layout = ({ children, isCentered, is404 }: LayoutProps) => {
  return (
    <StaticQuery
      query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              title
              description
              siteOrigin
            }
          }
        }
      `}
      render={data => (
        <>
          <Helmet
            defaultTitle={data.site.siteMetadata.title}
            titleTemplate={`%s | ${data.site.siteMetadata.title}`}
          >
            <script>
              {`
                !function(e,n,A){function o(e,n){return typeof e===n}function t(){var e,n,A,t,a,i,l;for(var f in r)if(r.hasOwnProperty(f)){if(e=[],n=r[f],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(A=0;A<n.options.aliases.length;A++)e.push(n.options.aliases[A].toLowerCase());for(t=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],l=i.split("."),1===l.length?Modernizr[l[0]]=t:(!Modernizr[l[0]]||Modernizr[l[0]]instanceof Boolean||(Modernizr[l[0]]=new Boolean(Modernizr[l[0]])),Modernizr[l[0]][l[1]]=t),s.push((t?"":"no-")+l.join("-"))}}function a(e){var n=u.className,A=Modernizr._config.classPrefix||"";if(c&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+A+"no-js(\\s|$)");n=n.replace(o,"$1"+A+"js$2")}Modernizr._config.enableClasses&&(n+=" "+A+e.join(" "+A),c?u.className.baseVal=n:u.className=n)}function i(e,n){if("object"==typeof e)for(var A in e)f(e,A)&&i(A,e[A]);else{e=e.toLowerCase();var o=e.split("."),t=Modernizr[o[0]];if(2==o.length&&(t=t[o[1]]),"undefined"!=typeof t)return Modernizr;n="function"==typeof n?n():n,1==o.length?Modernizr[o[0]]=n:(!Modernizr[o[0]]||Modernizr[o[0]]instanceof Boolean||(Modernizr[o[0]]=new Boolean(Modernizr[o[0]])),Modernizr[o[0]][o[1]]=n),a([(n&&0!=n?"":"no-")+o.join("-")]),Modernizr._trigger(e,n)}return Modernizr}var s=[],r=[],l={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var A=this;setTimeout(function(){n(A[e])},0)},addTest:function(e,n,A){r.push({name:e,fn:n,options:A})},addAsyncTest:function(e){r.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=l,Modernizr=new Modernizr;var f,u=n.documentElement,c="svg"===u.nodeName.toLowerCase();!function(){var e={}.hasOwnProperty;f=o(e,"undefined")||o(e.call,"undefined")?function(e,n){return n in e&&o(e.constructor.prototype[n],"undefined")}:function(n,A){return e.call(n,A)}}(),l._l={},l.on=function(e,n){this._l[e]||(this._l[e]=[]),this._l[e].push(n),Modernizr.hasOwnProperty(e)&&setTimeout(function(){Modernizr._trigger(e,Modernizr[e])},0)},l._trigger=function(e,n){if(this._l[e]){var A=this._l[e];setTimeout(function(){var e,o;for(e=0;e<A.length;e++)(o=A[e])(n)},0),delete this._l[e]}},Modernizr._q.push(function(){l.addTest=i}),Modernizr.addAsyncTest(function(){function e(e,n,A){function o(n){var o=n&&"load"===n.type?1==t.width:!1,a="webp"===e;i(e,a&&o?new Boolean(o):o),A&&A(n)}var t=new Image;t.onerror=o,t.onload=o,t.src=n}var n=[{uri:"data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=",name:"webp"},{uri:"data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==",name:"webp.alpha"},{uri:"data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA",name:"webp.animation"},{uri:"data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=",name:"webp.lossless"}],A=n.shift();e(A.name,A.uri,function(A){if(A&&"load"===A.type)for(var o=0;o<n.length;o++)e(n[o].name,n[o].uri)})}),t(),a(s),delete l.addTest,delete l.addAsyncTest;for(var p=0;p<Modernizr._q.length;p++)Modernizr._q[p]();e.Modernizr=Modernizr}(window,document);
              `}
            </script>

            <link rel="preconnect" href="https://fonts.gstatic.com" />

            <link
              rel="stylesheet"
              href="https://fonts.googleapis.com/css2?family=Heebo:wght@400;700&family=Lato:wght@400;700&display=swap"
            />

            <link
              rel="stylesheet"
              href="https://fonts.googleapis.com/css2?family=Heebo:wght@400;700&family=Lato:wght@400;700&display=swap"
            />
            <meta
              name="description"
              content={data.site.siteMetadata.description}
            />
            <meta
              name="og:description"
              content={data.site.siteMetadata.description}
            />
            <meta
              name="twitter:description"
              content={data.site.siteMetadata.description}
            />
            <meta
              name="image"
              content={`${data.site.siteMetadata.siteOrigin}${openGraphImage}`}
            />
            <meta
              name="og:image"
              content={`${data.site.siteMetadata.siteOrigin}${openGraphImage}`}
            />
            <meta
              name="twitter:image"
              content={`${data.site.siteMetadata.siteOrigin}${openGraphImage}`}
            />
            <link rel="apple-touch-icon" sizes="180x180" href={appleIcon} />
            <link rel="icon" type="image/png" sizes="32x32" href={favicon32} />
            <link rel="icon" type="image/png" sizes="16x16" href={favicon16} />
          </Helmet>
          <div id="modal"></div>
          <Div100vh
            className={classnames('background-image-container', {
              page404: is404,
            })}
          >
            <Div100vh className="site-container">
              <Header siteTitle={data.site.siteMetadata.title} />
              <main
                className={classnames('main-container', {
                  centered: isCentered,
                })}
              >
                {children}
              </main>
              <footer className="footer-container">
                <a
                  href="https://www.instagram.com/bantu.market/"
                  className="social-container margin-x-4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Instagram className="instagram-logo" />
                </a>
                <a
                  href="https://www.facebook.com/Bantu-111983340645934"
                  className="social-container margin-x-4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Facebook className="facebook-logo" />
                </a>
                <a
                  href="https://twitter.com/TheBantuMarket"
                  className="social-container margin-x-4"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Twitter className="twitter-logo" />
                </a>
                <span>© {new Date().getFullYear()} Bantu</span>
              </footer>
            </Div100vh>
          </Div100vh>
        </>
      )}
    />
  )
}

interface LayoutProps {
  children: any
  isCentered?: boolean
  is404?: boolean
}

export default Layout
